/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { NameValue } from '../tool/name-value';

/**
 * Builder object to build representation of contact
 * Use by {@link ListContactComponent}
 */
export class Contact {
  /**
   * Champs de nom
   */
  public nameField: string;
  /**
   * Champs de role
   */
  public roleField: string;
  /**
   * Champs de telephone
   */
  public phonesField: string[];
  /**
   * Champs de mail
   */
  public mailField: string;
  public prefField: string;

  public name: string;
  public address1: string;
  public address2: string;
  public phones: NameValue[];
  public mail: string;
  public web: string;

  public data: any[] = [];

  constructor(
    name: string,
    address1: string,
    address2: string,
    phones: NameValue[],
    mail: string,
    web: string
  ) {
    this.name = name;
    this.address1 = address1;
    this.address2 = address2;
    this.phones = phones;
    this.mail = mail;
    this.web = web;
  }

  public init(
    nameField: string,
    mailField?: string,
    phonesField?: string[],
    roleField?: string,
    prefField?: string
  ) {
    this.nameField = nameField;
    this.phonesField = phonesField;
    this.mailField = mailField;
    this.roleField = roleField;
    this.prefField = prefField;
  }

  public build(): any[] {
    const contacts = [];
    for (const d of this.data) {
      contacts.push({
        name: d[this.nameField],
        phones: this.getPhones(d),
        mail: this.mailField ? d[this.mailField] : '',
        role: this.roleField ? d[this.roleField] : '',
        pref: this.prefField ? d[this.prefField] : false,
      });
    }
    return contacts;
  }

  private getPhones(data: any): NameValue[] {
    const phones = [];
    if (this.phonesField) {
      for (const field of this.phonesField) {
        if (Object.hasOwn(data, field) && data[field]) {
          phones.push(new NameValue(field, data[field]));
        }
      }
    }
    return phones;
  }
}
